var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 9,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15L1.354 8.354a.5.5 0 010-.708L8 1",
    stroke: "#262a33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgOSAxNiIgd2lkdGg9IjkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTggMTUtNi42NDY0NS02LjY0NjQ1Yy0uMTk1MjYtLjE5NTI2LS4xOTUyNi0uNTExODQgMC0uNzA3MWw2LjY0NjQ1LTYuNjQ2NDUiIHN0cm9rZT0iIzI2MmEzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utb3BhY2l0eT0iLjgiLz48L3N2Zz4=";
export { SvgBack as ReactComponent };